module.exports = "https://www.gc-pro.gnp.com.mx/4c7cdc50a6cfdae921a7d571733eba36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_gastos.svg
// module id = 693
// module chunks = 0